<script lang="ts">
</script>

<div class="box scroll-x scroll-hidden box-height-full">
    <slot />
</div>
